import React from "react";
import { I_KonkurBookletPdf } from "../../../../Models/interfaces";
import { BsDownload, BsCartPlus, BsInfoCircle } from "react-icons/bs";

interface PdfItemProps {
  pdf: I_KonkurBookletPdf;
  onDownload: (pdf: I_KonkurBookletPdf) => void;
  onPurchase: (pdf: I_KonkurBookletPdf) => void;
}

const PdfItem: React.FC<PdfItemProps> = ({ pdf, onDownload, onPurchase }) => {
  const canDownload = pdf.has_paid || pdf.can_download;

  return (
    <div className="flex items-center justify-between p-2 bg-white rounded border border-gray-100 hover:shadow-sm transition">
      <div className="flex flex-col">
        <span className="text-sm text-gray-700">{pdf.title}</span>
        <div className="flex items-center gap-1 text-xs text-gray-500 mt-2 mr-2">
          <BsInfoCircle />
          <span className="text-xs text-gray-500">{pdf.description}</span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {!canDownload && pdf.price > 0 && (
          <span className="text-xs text-gray-400">{pdf.price} تومان</span>
        )}

        {canDownload ? (
          <button
            onClick={() => onDownload(pdf)}
            className="flex items-center gap-1 text-sm text-purple-600 hover:text-purple-800 transition"
          >
            <BsDownload />
            دانلود
          </button>
        ) : (
          <button
            onClick={() => onPurchase(pdf)}
            className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 transition"
          >
            <BsCartPlus />
            خرید
          </button>
        )}
      </div>
    </div>
  );
};

export default PdfItem;
